class Tabs {
	constructor(tabsId, contentsId) {
		this.tabsElement = document.getElementById(tabsId);
		this.tabs = Array.from(this.tabsElement.children);

		this.contentsElement = document.getElementById(contentsId);
		this.contents = Array.from(this.contentsElement.children);

		this.bindEvents();
		this.init();
	}

	bindEvents() {
		this.tabs.forEach((tab) => {
			tab.addEventListener("click", (e) => {
				e.preventDefault();
				this.switchTab(tab.dataset.tab);
			});
		});
	}

	init() {
		// Make the first tab active by default
		if (this.tabs.length > 0) {
			this.switchTab(this.tabs[0].dataset.tab);
		}
	}

	switchTab(tabId) {
		this.tabs.forEach((tab) => {
			tab.classList.remove("active");
		});

		this.contents.forEach((content) => {
			content.style.display = "none";
		});

		this.tabs.find((tab) => tab.dataset.tab === tabId).classList.add("active");

		let activeContent = this.contents.find(
			(content) => content.dataset.content === tabId
		);

		if (activeContent) {
			activeContent.style.display = "block";
		} else {
			console.log(`Content with id '${tabId}' not found.`);
		}
	}
}

export default Tabs;
